/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M17 7l-10 10", "key": "svg-0" }], ["path", { "d": "M8 7l9 0l0 9", "key": "svg-1" }]];
const IconArrowUpRight = createReactComponent("outline", "arrow-up-right", "ArrowUpRight", __iconNode);

export { __iconNode, IconArrowUpRight as default };
//# sourceMappingURL=IconArrowUpRight.mjs.map
